import './MatchingSection.css';

export const MatchingSection = ({ children }: { children: React.ReactNode }) => (
  <section className="matching-section">{children}</section>
);
